module.exports = __webpack_public_path__ + "files/c25b60c1c2618ddd9c5a7eae957fa74b.png";